export const CUSTOM_PROVINCES = [
  {
    code: '01',
    province: 'Vitoria-Gasteiz y Álava',
    slug: 'alava-araba'
  },
  {
    code: '07',
    province: 'Palma de Mallorca y Baleares',
    slug: 'islas-baleares'
  },
  {
    code: '20',
    province: 'San Sebastián y Guipúzcoa',
    slug: 'guipuzcoa-gipuzkoa'
  },
  {
    code: '26',
    province: 'Logroño y La Rioja',
    slug: 'la-rioja'
  },
  {
    code: '31',
    province: 'Pamplona y Navarra',
    slug: 'navarra'
  },
  {
    code: '33',
    province: 'Oviedo y Asturias',
    slug: 'asturias'
  },
  {
    code: '39',
    province: 'Santander y Cantabria',
    slug: 'cantabria'
  },
  {
    code: '48',
    province: 'Bilbao y Vizcaya',
    slug: 'vizcaya-bizkaia'
  }
];

// Las 52 provincias, en local. El nombre visible no puede depender de una petición: si
// depende, el primer render pinta el slug en crudo ('madrid') y lo sustituye al llegar la
// respuesta. Con esto está disponible desde el primer pintado y nos ahorramos la llamada
// a bff/advisors/provinces, que solo servía para traducir el slug.
// CUSTOM_PROVINCES tiene prioridad sobre esta lista.
export const PROVINCES = [
  { code: '01', slug: 'alava-araba', province: 'Álava/Araba' },
  { code: '02', slug: 'albacete', province: 'Albacete' },
  { code: '03', slug: 'alicante-alacant', province: 'Alicante/Alacant' },
  { code: '04', slug: 'almeria', province: 'Almería' },
  { code: '05', slug: 'avila', province: 'Ávila' },
  { code: '06', slug: 'badajoz', province: 'Badajoz' },
  { code: '07', slug: 'islas-baleares', province: 'Islas Baleares/Illes Balears' },
  { code: '08', slug: 'barcelona', province: 'Barcelona' },
  { code: '09', slug: 'burgos', province: 'Burgos' },
  { code: '10', slug: 'caceres', province: 'Cáceres' },
  { code: '11', slug: 'cadiz', province: 'Cádiz' },
  { code: '12', slug: 'castellon-castello', province: 'Castellón/Castelló' },
  { code: '13', slug: 'ciudad-real', province: 'Ciudad Real' },
  { code: '14', slug: 'cordoba', province: 'Córdoba' },
  { code: '15', slug: 'a-coruna', province: 'A Coruña' },
  { code: '16', slug: 'cuenca', province: 'Cuenca' },
  { code: '17', slug: 'girona', province: 'Girona' },
  { code: '18', slug: 'granada', province: 'Granada' },
  { code: '19', slug: 'guadalajara', province: 'Guadalajara' },
  { code: '20', slug: 'guipuzcoa-gipuzkoa', province: 'Guipúzcoa/Gipuzkoa' },
  { code: '21', slug: 'huelva', province: 'Huelva' },
  { code: '22', slug: 'huesca', province: 'Huesca' },
  { code: '23', slug: 'jaen', province: 'Jaén' },
  { code: '24', slug: 'leon', province: 'León' },
  { code: '25', slug: 'lleida', province: 'Lleida' },
  { code: '26', slug: 'la-rioja', province: 'La Rioja' },
  { code: '27', slug: 'lugo', province: 'Lugo' },
  { code: '28', slug: 'madrid', province: 'Madrid' },
  { code: '29', slug: 'malaga', province: 'Málaga' },
  { code: '30', slug: 'murcia', province: 'Murcia' },
  { code: '31', slug: 'navarra', province: 'Navarra' },
  { code: '32', slug: 'ourense', province: 'Ourense' },
  { code: '33', slug: 'asturias', province: 'Asturias' },
  { code: '34', slug: 'palencia', province: 'Palencia' },
  { code: '35', slug: 'las-palmas', province: 'Las Palmas' },
  { code: '36', slug: 'pontevedra', province: 'Pontevedra' },
  { code: '37', slug: 'salamanca', province: 'Salamanca' },
  { code: '38', slug: 'santa-cruz-de-tenerife', province: 'Santa Cruz de Tenerife' },
  { code: '39', slug: 'cantabria', province: 'Cantabria' },
  { code: '40', slug: 'segovia', province: 'Segovia' },
  { code: '41', slug: 'sevilla', province: 'Sevilla' },
  { code: '42', slug: 'soria', province: 'Soria' },
  { code: '43', slug: 'tarragona', province: 'Tarragona' },
  { code: '44', slug: 'teruel', province: 'Teruel' },
  { code: '45', slug: 'toledo', province: 'Toledo' },
  { code: '46', slug: 'valencia', province: 'Valencia' },
  { code: '47', slug: 'valladolid', province: 'Valladolid' },
  { code: '48', slug: 'vizcaya-bizkaia', province: 'Vizcaya/Bizkaia' },
  { code: '49', slug: 'zamora', province: 'Zamora' },
  { code: '50', slug: 'zaragoza', province: 'Zaragoza' },
  { code: '51', slug: 'ceuta', province: 'Ceuta' },
  { code: '52', slug: 'melilla', province: 'Melilla' }
];
